import i18n from 'i18n/config';

export const getHelpCenterLink = () =>
  i18n.t('shared:auth_wrapper_help_centre.faq_link.url');
